import React from "react";
import {css, Theme} from "@emotion/react";

import {mb, mh, pb, pl} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {VendorDetailRankingBox} from "./boxes/VendorDetailRankingBox";

interface IProps {
    vendor: {
        id: number;
        slug: string;
    };
    rankings: IRanking[];
}

interface IRanking {
    id: number;
    offer: {
        id: number;
        main_image: {
            m_img_760x428: string;
        };
        name: string;
        slug: string;
    };
    position: number;
    region: {
        name: string;
        slug: string;
    };
    quarter: number;
    year: number;
}

const createRankingLink = (ranking: IRanking) =>
    rpAppLink.ranking.lastYearList({
        citySlug: ranking.region.slug
    });

export const VendorDetailOfferRanking = (props: IProps) => {
    const {rankings} = props;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[pb(4)]}>
                Nagrody i wyróżnienia
            </Text>

            <Text as="h3" variant="body_copy_1" css={[pb(5)]}>
                Ranking najlepszych inwestycji - użytkownicy docenili nasze inwestycje
            </Text>

            <ul css={vendorDetailRankingList}>
                {rankings.map((ranking) => (
                    <li key={ranking.id + ranking.offer.slug} css={vendorDetailRankingListElement}>
                        <VendorDetailRankingBox ranking={ranking} linkToRanking={createRankingLink(ranking)} />
                    </li>
                ))}
            </ul>
        </>
    );
};

const vendorDetailRankingList = (theme: Theme) => css`
    list-style: none;
    ${pl(0)};
    ${mb(5)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(6)};
    }
`;

const vendorDetailRankingListElement = (theme: Theme) => css`
    max-width: 375px;
    ${pb(2)};
    ${mh("auto")};

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 100%;
        ${pb(3)};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {mb, mh, pb, pl} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {VendorDetailRankingBox} from "./boxes/VendorDetailRankingBox";

interface IProps {
    vendor: {
        id: number;
        slug: string;
    };
    rankings: IRanking[];
}

interface IRanking {
    id: number;
    offer: {
        id: number;
        main_image: {
            m_img_760x428: string;
        };
        name: string;
        slug: string;
    };
    position: number;
    region: {
        name: string;
        slug: string;
    };
    quarter: number;
    year: number;
}

const createRankingLink = (ranking: IRanking) =>
    rpAppLink.ranking.lastYearList({
        citySlug: ranking.region.slug
    });

export const VendorDetailOfferRanking = (props: IProps) => {
    const {rankings} = props;

    return (
        <>
            <Text as="h2" variant="headline_3" css={[pb(4)]}>
                Nagrody i wyróżnienia
            </Text>

            <Text as="h3" variant="body_copy_1" css={[pb(5)]}>
                Ranking najlepszych inwestycji - użytkownicy docenili nasze inwestycje
            </Text>

            <ul css={vendorDetailRankingList}>
                {rankings.map((ranking) => (
                    <li key={ranking.id + ranking.offer.slug} css={vendorDetailRankingListElement}>
                        <VendorDetailRankingBox ranking={ranking} linkToRanking={createRankingLink(ranking)} />
                    </li>
                ))}
            </ul>
        </>
    );
};

const vendorDetailRankingList = (theme: Theme) => css`
    list-style: none;
    ${pl(0)};
    ${mb(5)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(6)};
    }
`;

const vendorDetailRankingListElement = (theme: Theme) => css`
    max-width: 375px;
    ${pb(2)};
    ${mh("auto")};

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 100%;
        ${pb(3)};
    }
`;
